export default __webpack_public_path__ + "img/654cb8d3866c0e6e9412a12fcad3c9a1.jpg";